import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return ({ filter, sort, size, index }) =>
    present(
      repository
        .getProjects(filter, sort, size, index)
        .then((projects) => ({ filter, sort, size, index, projects }))
        .catch(() => Promise.reject({ filter, sort, size, index })),
    );
}

export type { Interactor };

export { createInteractor };
